import { Constants as MoltenConstants } from '@leverege/molten';
import { Attributes } from '@leverege/ui-attributes';
import { createColumnRenderer, createDetailRenderer } from "../attributes/renderers/FotaLoaderRenderer.js";
import { Types } from "../constants/index.js";
function createLinkedAttributeForType(attr, type, molten) {
  const linkedType = attr.valueType;
  const linkedAttrs = Attributes.getAttributesFor(linkedType);
  linkedAttrs.forEach(linkedAttr => {
    const attribute = {
      ...linkedAttr,
      objectType: attr.objectType,
      name: `${attr.name}$${linkedAttr.name}`,
      displayName: `${attr.displayName} ${linkedAttr.displayName}`,
      get: (object, context) => {
        const linkedObj = attr.get(object, context);
        return linkedAttr.get(linkedObj, context);
      },
      load: linkedAttr.load ? async (object, context) => {
        await attr.load(object, context);
        const linkedObj = attr.get(object, context);
        return linkedAttr.load(linkedObj, context);
      } : attr.load,
      source: {
        ...attr?.source,
        forwarded: true
      }
      // put setters here
    };
    molten.addPlugin('Attribute', attribute);
    molten.addPlugin('AttributeCellRenderer', {
      objectType: attr.objectType,
      attrName: attribute.name,
      renderer: createColumnRenderer(attribute.name, attribute.objectType),
      handles: () => true
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: attr.objectType,
      attrName: attribute.name,
      renderer: createDetailRenderer(attribute.name, attribute.objectType)
    });
  });
}
function createLinkedAttributesForType(type, molten) {
  const attrs = Attributes.getAttributesFor(type).filter(attr => attr.linkAttributes);
  attrs.forEach(attr => createLinkedAttributeForType(attr, type, molten));
}
function createLinkedAttributes(molten, blueprints) {
  Types.toCheckForLinkedAttributes.forEach(type => createLinkedAttributesForType(type, molten));
}
const LinkedAttributeAnalyzer = {
  type: MoltenConstants.BLUEPRINTS_PROCESSOR,
  id: `${Types.apiName}.LinkedAttributeAnalyzer`,
  processBlueprints: createLinkedAttributes
};
export default LinkedAttributeAnalyzer;